import { OnMessageCallback } from 'mqtt';
import { telemetryActions } from './telemetrySlice';
import { store } from '../../app/store';

export const telemetryStopMqttParser: OnMessageCallback = (topic: any, payload: any, packet: any): void => {
    store.dispatch(telemetryActions.new_stop({ label: topic.split("/").slice(-1)[0], stop: JSON.parse(payload.toString())?.stop || false }))
};